<template>
  <section v-if="accountRole !== undefined">
    <b-tabs
      :value="activeTabIndex"
      @input="onChangeTab"
    >
      <b-tab
        :title="$tk('ClientPortal.Account.Edit.Account')"
      >
        <AccountEdit v-if="visitedTabs.includes(0)" />
      </b-tab>
      <b-tab
        :title="$tk('ClientPortal.Account.Edit.Users')"
      >
        <AccountUsers v-if="visitedTabs.includes(1)" />
      </b-tab>
      <b-tab
        v-if="accountAccessManager.canSeeAPIKeys()"
        :title="$tk('ClientPortal.Account.Edit.ApiKeys')"
      >
        <AccountApiKeys v-if="visitedTabs.includes(2)" />
      </b-tab>
      <b-tab
        v-if="configuration.clientConfiguration.showUserInvitations"
        :title="$tk('ClientPortal.Account.Edit.Invitations')"
      >
        <AccountInvitations v-if="visitedTabs.includes(3)" />
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { AccountAccessManager } from '@/utils/accessManager/accessManager'
import store from '@/store'
import AccountUsers from './AccountUsers.vue'
import AccountEdit from './AccountEdit.vue'
import AccountInvitations from './AccountInvitations.vue'
import AccountApiKeys from './AccountApiKeys.vue'

export default {
  components: {
    AccountUsers,
    AccountEdit,
    AccountInvitations,
    AccountApiKeys,
  },
  data() {
    return {
      visitedTabs: [],
      tabHashes: ['#account', '#users', '#apikeys', '#invitations'],
      accountAccessManager: AccountAccessManager,
      currentTab: null,
    }
  },
  computed: {
    accountRole() {
      const { accountRole } = store.getters['verticalMenu/accountContext']
      return accountRole
    },
    activeTabIndex() {
      let route = this.$route.hash.toLowerCase()
      if (route === '#apikeys' && !this.accountAccessManager.canSeeAPIKeys()) {
        const index = this.tabHashes.findIndex(x => x === route) + 1
        this.onChangeTab(index)
      }
      if (!route) {
        route = this.currentTab
      }
      return this.tabHashes.findIndex(x => x === route) || 0
    },
    ...mapGetters(['configuration']),
  },
  mounted() {
    const route = this.$route.hash.toLowerCase()
    this.currentTab = route
    this.visitedTabs.push(this.tabHashes.findIndex(x => x === route) || 0)
  },
  methods: {
    onChangeTab(tab) {
      if (!this.visitedTabs.includes(tab)) {
        this.visitedTabs.push(tab)
      }

      const tableRow = document.getElementsByClassName('table-row-animation')
      if (tableRow.length) {
        tableRow[0].classList.remove('table-row-animation')
      }

      const hash = this.tabHashes[tab]
      this.currentTab = hash
      this.$router.replace({ hash })
    },
  },
}
</script>
